import { Navigate, useParams } from 'react-router-dom'

/**
 * @param newPath - the new path to redirect to
 * @param paramMapping - the mapping of url params to query params
 * @returns a redirect component that redirects to the new path with the query params
 */
export const createParamRedirect =
  (newPath: string, paramMapping: Record<string, string>) => () => {
    const params = useParams()
    const queryParams = new URLSearchParams()
    Object.entries(paramMapping).forEach(([urlParam, queryParam]) => {
      if (params[urlParam]) {
        queryParams.set(queryParam, params[urlParam]!)
      }
    })
    const queryString = queryParams.toString()
    const to = `${newPath}${queryString ? `?${queryString}` : ''}`
    return <Navigate to={to} replace />
  }
